import React from 'react'
import cx from 'classnames'
import NavLink from '../../components/NavLink'

import CircleDecor6 from '../../components/Svg/circle-decor-6'
import CircleDecor7 from '../../components/Svg/circle-decor-7'
import RGlow from '../../components/Svg/radial-glow'

export default ({icon, label, link, className, style, ...props}) => (
  <NavLink to={ link } className={cx("btn btn-nav-item btn-xl", className)} style={style}>
		<div className="btn__label btn__label__center"> { label } </div>
		<div className="btn__circles">
			<div className="btn__circles__item"><CircleDecor6 /></div>
			<div className="btn__circles__item"><CircleDecor7 /></div>
		</div>
		<div className="btn__glow">
			<RGlow />
		</div>
	</NavLink>
)
